import { render, staticRenderFns } from "./PermissionSingle.vue?vue&type=template&id=0a34a898&"
import script from "./PermissionSingle.vue?vue&type=script&lang=js&"
export * from "./PermissionSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports